import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { resetChat } from '../../../actions/chat/actions';
import { setChatListInitial } from '../../../actions/chatList';
import { getChats } from '../../../actions/chatList/getChats';
import { selectSubAgent } from '../../../actions/masterFilters';
import { setSubAgentsSearch } from '../../../actions/subAgents';
import { SubAgentSearchItem } from '../../../components/SubAgentSearchItem';
import { useSubAgentSelectTracking } from '../../../hooks';
import { subAgentsSelector } from '../../../selectors';

export const useSubAgents = (): React.ReactNode | null => {
  const { subAgentsList } = useSelector(subAgentsSelector);

  const dispatch = useDispatch();

  const handleTracking = useSubAgentSelectTracking();

  const handleUpdateChats = React.useCallback(() => {
    dispatch(setSubAgentsSearch({ search: '' }));
    dispatch(setChatListInitial());
    dispatch(resetChat());
    dispatch(getChats({}));
  }, [dispatch]);

  const handleClick = React.useCallback(
    (subAgentId: number) => {
      dispatch(selectSubAgent({ subAgentId }));
      handleUpdateChats();
      handleTracking(subAgentId);
    },
    [dispatch, handleTracking, handleUpdateChats],
  );

  return React.useMemo(() => {
    if (subAgentsList.length) {
      return subAgentsList.map(subAgent => (
        <SubAgentSearchItem key={subAgent.userId} subAgent={subAgent} onClick={handleClick} />
      ));
    }

    return null;
  }, [handleClick, subAgentsList]);
};
